<!DOCTYPE html>
<html lang="en">
<head>
    <script>
        document.documentElement.classList.add('js-enabled');
        window.foucTimeout = setTimeout(function() {
            document.documentElement.classList.remove('js-enabled');
        }, 2000);
    </script>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="theme-color" content="#F8F9FA">
    <link rel="preload" as="font" href="fonts/Lato-Regular.woff2" type="font/woff2" crossorigin>
    <link rel="preload" as="font" href="fonts/Lato-Bold.woff2" type="font/woff2" crossorigin>
    <link rel="preload" as="font" href="fonts/Fredoka-SemiBold.woff2" type="font/woff2" crossorigin>
    
    <title>Privacy Policy | Little Explorers Nursery</title>
    <link rel="icon" type="image/svg+xml" href="images/logo.svg">
    <meta name="description" content="Read our Privacy Policy to understand how we collect, store, and protect your data in accordance with UK GDPR.">
    <!-- 2026 AI Agent Discovery Links -->
    <link rel="alternate" type="text/plain" title="LLM Summary (Low Token)" href="/llms.txt">
    <link rel="alternate" type="text/plain" title="LLM Full Knowledge Base (High Token)" href="/llms-full.txt">
    
    <meta property="og:type" content="article">
    <meta property="og:url" content="https://littleexplorersnursery.example.com/privacy">
    <meta property="og:title" content="Privacy Policy | Little Explorers Nursery">
    <meta property="og:description" content="How we collect, store, and protect your personal data.">
    <meta property="og:image" content="https://littleexplorersnursery.example.com/images/og-image.jpg">
    
    <link rel="stylesheet" href="css/style.css">
    <script defer src="/vendor/gsap.min.js"></script>
    <script defer src="/vendor/ScrollTrigger.min.js"></script>
    <script type="module" src="/js/main.js"></script>
    <script type="module" src="/js/global-animations.js"></script>
    <script type="module" src="/js/policy.js"></script>
</head>
<body>

    <!-- MOBILE NAVBAR START -->
    <nav class="mobile-navbar" aria-label="Mobile top bar">
        <a href="/" class="mobile-logo-link">
            <img src="images/logo.svg" alt="Little Explorers Nursery Logo" class="mobile-logo" width="45" height="44" loading="eager">
        </a>
        <button type="button" class="mobile-menu-toggle" aria-label="Toggle navigation" aria-expanded="false">
            <span class="bar"></span>
            <span class="bar"></span>
        </button>
    </nav>

    <!-- MOBILE CURTAIN OVERLAY -->
    <div class="mobile-menu-overlay" aria-hidden="true" style="display: none;">
        <nav class="mobile-overlay-nav">
            <ul class="mobile-overlay-list">
                <li><a href="/" class="mobile-overlay-link">Home</a></li>
                <li><a href="rooms" class="mobile-overlay-link">Our Rooms</a></li>
                <li><a href="staff" class="mobile-overlay-link">Our Team</a></li>
                <li><a href="fees" class="mobile-overlay-link">Fees & Info</a></li>
                <li><a href="contact" class="mobile-overlay-link cta-pill">Book a Tour</a></li>
            </ul>
        </nav>
    </div>

    <!-- DESKTOP NAVBAR START -->
    <header class="site-header">
        <div class="container header-inner">
            <a href="/" class="logo-link">
                <img src="images/logo.svg" alt="Little Explorers Nursery Logo" class="site-logo" width="61" height="60" loading="eager">
            </a>
            <nav class="nav-links">
                <a href="/">Home</a>
                <a href="rooms">Our Rooms</a>
                <a href="staff">Our Team</a>
                <a href="fees">Fees & Info</a>
            </nav>
            <div class="header-cta">
                <a href="contact" class="btn btn-primary">Book a Tour</a>
            </div>
        </div>
    </header>

    <main>
        <!-- ESCAPE HATCH BANNER -->
        <div class="escape-hatch-banner">
            <div class="container escape-hatch-inner">
                <div class="escape-actions">
                    <a href="/" id="smart-escape-btn" class="btn btn-escape" style="visibility: hidden;"></a>
                    <script>
                        (function() {
                            var btn = document.getElementById('smart-escape-btn');
                            var referrer = document.referrer;
                            if (referrer && referrer.includes(window.location.hostname)) {
                                btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg> Back to Previous Page';
                                btn.addEventListener('click', function(e) {
                                    e.preventDefault();
                                    history.back();
                                });
                            } else {
                                btn.innerHTML = 'Discover Our Nursery <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>';
                            }
                            btn.style.visibility = 'visible';
                        })();
                    </script>
                </div>
                <div class="escape-text">
                    <span class="mask-icon icon-info" style="-webkit-mask-image: url('images/icons/info.svg'); mask-image: url('images/icons/info.svg'); width: 20px; height: 20px; background-color: var(--color-primary);"></span>
                    <p><strong>Looking for childcare in Anytown?</strong> Explore our beautiful nursery spaces and book a tour today.</p>
                </div>
            </div>
        </div>

        <section class="policy-section section-padding" style="position: relative;">
            <div class="container">
                <div class="policy-header text-center">
                    <!-- Left & Right H1 Framing Doodles -->
                    <svg class="header-doodle doodle-left" viewBox="0 0 100 100" fill="none" stroke="var(--color-primary-light)" stroke-width="6" stroke-linecap="round"><use href="images/svgs/sprites.svg#doodle-8"></use></svg>
                    <svg class="header-doodle doodle-right doodle-plane" viewBox="0 0 100 100" fill="none" stroke="var(--color-accent)" stroke-width="5" stroke-linecap="round"><use href="images/svgs/sprites.svg#doodle-14"></use></svg>
                    
                    <h1>Website Privacy Policy</h1>
                    <p class="last-updated">Last Updated: <time datetime="2026-06" class="tldr-stat">June 2026</time></p>
                </div>

                <div class="policy-layout">
                    
                    <!-- LEFT COLUMN: CONTENT -->
                    <article class="policy-content">
                        
                        <h2 id="introduction">1. Introduction</h2>
                        <p>Welcome to Little Explorers Nursery's Privacy Policy. We respect your privacy and are committed to protecting your personal data. This policy explains how we collect, process, and securely store your data when you visit our website or use our "Book a Tour" and contact forms.</p>
                        <p>This policy complies with the <strong class="tldr-stat">UK General Data Protection Regulation (UK GDPR)</strong> and the Data Protection Act 2018.</p>

                        <h2 id="data-we-collect">2. The Data We Collect</h2>
                        <p>When you interact with our website to request information or book a tour, we may collect the following information:</p>
                        <ul>
                            <li><strong>Identity Data:</strong> Your first and last name.</li>
                            <li><strong>Contact Data:</strong> Your email address and telephone number.</li>
                            <li><strong>Child Data:</strong> Your child's name, expected start date, and date of birth/due date (required to ensure we can meet age-specific ratios).</li>
                            <li><strong>Technical Data:</strong> Anonymous analytical data such as browser type, time zone, and IP address (strictly used to ensure website functionality and security).</li>
                        </ul>

                        <h2 id="how-we-use-data">3. How We Use Your Data</h2>
                        <p>We will only use your personal data when the law allows us to. Most commonly, we use your data to:</p>
                        <ul>
                            <li>Process your request to book a tour of the nursery.</li>
                            <li>Contact you regarding availability, waiting lists, or registration processes.</li>
                            <li>Reply to any queries you send via email or phone.</li>
                        </ul>
                        <p>Our lawful basis for processing this data is your <strong class="tldr-stat">explicit consent</strong> (provided when checking the consent box on our web forms) and our legitimate interest in responding to customer inquiries.</p>

                        <h2 id="data-retention">4. Data Retention & Storage</h2>
                        <p>We only retain your personal data for as long as necessary to fulfil the purposes we collected it for. If you enquire about a place but do not subsequently register your child, your digital inquiry details will be securely deleted after <strong class="tldr-stat">12 months</strong>.</p>
                        <p>If your child joins the nursery, your data will be transferred to our secure nursery management system and retained in accordance with Ofsted statutory requirements.</p>

                        <h2 id="third-parties">5. Sharing Your Data</h2>
                        <p>We treat your data with the utmost strictness. <strong class="tldr-stat">We do not sell, trade, or rent your personal information to third parties.</strong></p>
                        <p>Data may be processed by trusted third-party service providers (such as secure web hosting and encrypted email servers) strictly for the purpose of operating this website and facilitating communication with you.</p>

                        <h2 id="your-rights">6. Your Legal Rights</h2>
                        <p>Under UK GDPR, you have several rights regarding your personal data, including the right to:</p>
                        <ul>
                            <li>Request access to your personal data.</li>
                            <li>Request correction of incomplete or inaccurate data.</li>
                            <li><strong>Request erasure</strong> (the "right to be forgotten") of your data where there is no good reason for us continuing to process it.</li>
                            <li>Withdraw consent at any time.</li>
                        </ul>
                        <p>If you wish to exercise any of these rights, please contact us using the details below.</p>

                        <h2 id="cookies">7. Cookies</h2>
                        <p>Our website uses essential cookies to ensure the website functions correctly and securely. We do not use invasive third-party tracking cookies for advertising purposes.</p>

                        <h2 id="contact-us">8. Contact Us</h2>
                        <p>If you have any questions about this Privacy Policy or our data protection practices, please contact us:</p>
                        <ul>
                            <li><strong>Email:</strong> hello@littleexplorersnursery.example.com</li>
                            <li><strong>Phone:</strong> 020 7946 0123</li>
                            <li><strong>Address:</strong> 13 Anytown Green, Anycity AT1 5LB</li>
                        </ul>
                        <p>You also have the right to make a complaint at any time to the Information Commissioner's Office (ICO), the UK supervisory authority for data protection.</p>

                    </article>

                    <!-- RIGHT COLUMN: STICKY SIDEBAR -->
                    <aside class="policy-sidebar">
                        <div class="sidebar-sticky">
                            <!-- No PDF box needed for Privacy Policy -->
                            <nav class="toc-nav" aria-label="Table of Contents">
                                <h4>Table of Contents</h4>
                                <ul>
                                    <li><a href="#introduction">1. Introduction</a></li>
                                    <li><a href="#data-we-collect">2. Data We Collect</a></li>
                                    <li><a href="#how-we-use-data">3. How We Use Data</a></li>
                                    <li><a href="#data-retention">4. Data Retention</a></li>
                                    <li><a href="#third-parties">5. Third Parties</a></li>
                                    <li><a href="#your-rights">6. Your Legal Rights</a></li>
                                    <li><a href="#cookies">7. Cookies</a></li>
                                    <li><a href="#contact-us">8. Contact Us</a></li>
                                </ul>
                            </nav>
                        </div>
                    </aside>

                </div>
            </div>
        </section>

        <!-- FOOTER START -->
        <footer class="site-footer">
            <div class="container">
                <div class="footer-grid">
                    <div class="footer-col brand-col">
                        <h3 class="footer-logo-text"><span translate="no">Little Explorers Nursery</span></h3>
                        <p>A nurturing, home-from-home early years setting in the heart of Anytown, Anycity.</p>
                        <div class="footer-badges">
                            <a href="https://ratings.food.gov.uk/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src="images/svgs/fhrs-badge-5.svg" alt="Food Hygiene Rating 5" class="footer-badge-img" width="160" height="80">
                            </a>
                            <a href="https://reports.ofsted.gov.uk/" target="_blank" rel="noopener noreferrer" aria-label="Read our Ofsted Report">
                                <img loading="lazy" src="images/svgs/Ofsted_Good_GP_White.svg" alt="Ofsted Good Provider" class="ofsted-footer-badge" width="60" height="60">
                            </a>
                        </div>
                    </div>
                    <div class="footer-col links-col">
                        <h4>Explore</h4>
                        <ul>
                            <li><a href="/">Home</a></li>
                            <li><a href="rooms">Our Rooms</a></li>
                            <li><a href="staff">Our Team</a></li>
                            <li><a href="fees">Fees & Funding</a></li>
                            <li><a href="contact">Contact</a></li>
                        </ul>
                    </div>
                    <div class="footer-col contact-col">
                        <h4>Get in Touch</h4>
                        <address>
                            <ul>
                                <li><strong>A:</strong> <a href="https://maps.google.com/?q=13+Anytown+Green,+Anycity+AT1+5LB" target="_blank" rel="noopener noreferrer">13 Anytown Green, Anycity AT1 5LB</a></li>
                                <li><strong>T:</strong> <a href="tel:+442079460123">020 7946 0123</a></li> 
                                <li><strong>E:</strong> <a href="mailto:hello@littleexplorersnursery.example.com">hello@littleexplorersnursery.example.com</a></li>
                            </ul>
                        </address>
                        <h4 class="hours-title">Opening Hours</h4>
                        <p class="hours-text"><span>Mon - Fri: 8:00am - 6:00pm</span><span>Sat - Sun: Closed</span></p>
                    </div>
                </div>
                <div class="footer-bottom">
                    <p>&copy; <span id="current-year"></span> All Rights Reserved - <a href="https://selcreative.co.uk/" target="_blank" rel="noopener noreferrer">SEL Creative</a></p>
                    <div class="legal-links">
                        <a href="privacy">Privacy Policy</a>
                        <span class="divider">|</span>
                        <a href="safeguarding">Safeguarding Policy</a>
                    </div>
                </div>
            </div>
        </footer>
    </main>

</body>
</html>
